export enum DateFilterTypes {
  Last24h = 'Last 24h',
  Last7Days = 'Last 7 Days',
  Last30Days = 'Last 30 Days',
}